import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useInitOfSavingClearPath } from '../../hooks/useBackButton'

import Title from '../../components/ui/title/title'

import FavoriteTabs from '../../components/profile/favorites/FavoritesTabs'
import PageHeader from '../../components/profile/pageHeader'

import Pagination from 'rsuite/Pagination'
import { META } from '../../constants/meta'
import { Helmet } from 'react-helmet'
import isNull from 'lodash/isNull'

import { RootState } from '../../store/rootReducer'

import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { fetchFavoriteContributionsList } from '../../store/member/memberSlice'
import { checkAuth, loadMemberFavoriteContributionsList } from '../../utils/auth'
import ContributionPreview from '../../components/contribution/contributionPreview'
import paths from '../../paths'
import '../index/pagination.sass'
import './favoriteContributions.sass'

const FavoriteContributors = () => {
    useInitOfSavingClearPath()
    usePageLoaded()

    const [t] = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()

    const { user, favoriteContributions, favoriteContributionsTotal } = useSelector((state: RootState) => state.member)

    const [activePage, setActivePage] = useState(1)

    const isAgeVerified = useSelector((state: RootState) => state.common.isAgeVerified)

    useEffect(() => {
        dispatch(fetchFavoriteContributionsList({ p: activePage }))
    }, [activePage])

    useEffect(() => {
        if (favoriteContributionsTotal / 20 == activePage - 1) setActivePage(activePage - 1 || 1)
    }, [favoriteContributionsTotal])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.favoriteContributions[getLangFromPath(location.pathname)].title}</title>
                <meta
                    name="description"
                    content={META.favoriteContributions[getLangFromPath(location.pathname)].description}
                />
            </Helmet>
            <div className="pageRow">
                <PageHeader user={user} text={t('My favorite')} self />
            </div>
            <FavoriteTabs />
            {favoriteContributions.length ? (
                <div className={'snapshotList'}>
                    {favoriteContributions.map((contribution) => (
                        <ContributionPreview
                            contribution={contribution}
                            key={contribution.id}
                            favorite
                            activePage={activePage}
                            isAgeVerified={isAgeVerified}
                        />
                    ))}
                </div>
            ) : (
                <Title text={'You have no favorite contributions'} secondary />
            )}

            <div className="paginationWrapper">
                <Pagination
                    limit={20}
                    limitOptions={[20]}
                    maxButtons={5}
                    activePage={activePage}
                    prev
                    next
                    onChangePage={(page: number) => {
                        dispatch(fetchFavoriteContributionsList({ p: page }))
                        setActivePage(page)
                    }}
                    total={favoriteContributionsTotal}
                />
            </div>
        </div>
    )
}

// @ts-ignore
FavoriteContributors.getInitialProps = async ({ req, store }) => {
    await checkAuth(store)
    const {
        member: { loggedIn, favoriteContributionsTotal }
    } = store.getState()

    if (loggedIn && isNull(favoriteContributionsTotal)) {
        await loadMemberFavoriteContributionsList(store)
    } else {
        if (!loggedIn)
            return {
                redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${
                    paths.favoriteContributions.path
                }`
            }
    }
}

export default FavoriteContributors
